import { DependencyContainer } from '../../../DependencyContainer';
import {
  LocationAttributes,
  MonitorApiPayload,
  Operator,
} from '../components/AddMonitor/types';
import { FilterData, Monitor } from '../types';

export default class MonitorsService {
  constructor(private readonly factory: DependencyContainer) {}

  async getMonitorListItems(partnerId: string): Promise<Monitor[]> {
    const response = await this.factory.monitorsClient.fetchMonitorListItems(
      partnerId,
    );
    return response.data;
  }
  async deleteMonitor(partnerId: string, monitorId: string): Promise<void> {
    await this.factory.monitorsClient.deleteMonitor(partnerId, monitorId);
  }

  async getMonitorId(partnerId: string, monitorId: string): Promise<Monitor> {
    const response = await this.factory.monitorsClient.getMonitor(
      partnerId,
      monitorId,
    );
    return response.data;
  }

  async createMonitor(
    partnerId: string,
    monitor: MonitorApiPayload,
  ): Promise<Monitor> {
    const response = await this.factory.monitorsClient.createMonitor(
      partnerId,
      monitor,
    );
    return response?.data;
  }

  async patchMonitor(
    partnerId: string,
    monitorId: string,
    monitor: MonitorApiPayload,
  ): Promise<Monitor> {
    const response = await this.factory.monitorsClient.updateMonitor(
      partnerId,
      monitorId,
      monitor,
    );
    return response?.data;
  }
  async getDynamicFilterData(
    partnerId: string,
    filters: LocationAttributes,
  ): Promise<FilterData> {
    const response = await this.factory.monitorsClient.getDynamicFilter(
      partnerId,
      {
        ...filters,
        operator: filters.operator.toLowerCase() as Operator,
      },
    );
    return response?.data;
  }

  async getAutonomousMonitorsList(partnerId: string) {
    const response = await this.factory.monitorsClient.getAutonomousMonitorsList(
      partnerId,
    );
    return response.data;
  }

  async getAutonomousMonitor(partnerId: string, monitorId: string) {
    const response = await this.factory.monitorsClient.getAutonomousMonitor(
      partnerId,
      monitorId,
    );
    return response.data;
  }
}
